import { ICalendarDialogFormData } from "dataModels/b2b";
import moment from "moment";
import { DATE_FORMAT } from "shared/constants";

export const onDateInputChange = (inputEvent: Event,currentData:ICalendarDialogFormData) => {
    const date: string = (inputEvent as CustomEvent).detail.dateSelection;
    const dates = date.split(' - ');
    //console.log(dates)
    const startDateTimestamp = moment.utc(dates[0], DATE_FORMAT).unix(); //UTC VERIFICARE
    const endDateTimestamp = moment.utc(dates[1], DATE_FORMAT).unix(); //UTC VERIFICARE
    //console.log(startDateTimestamp + " - " + endDateTimestamp);
    (currentData['startDate' as keyof ICalendarDialogFormData] as number) = startDateTimestamp;
    (currentData['endDate' as keyof ICalendarDialogFormData] as number) = endDateTimestamp;
    return currentData;
}